
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import DocumentAnalysisContent from "@/components/expertise/DocumentAnalysisContent";

const DocumentAnalysis = () => {
  useEffect(() => {
    document.title = "AI Document Analysis & Drafting | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI document analysis & drafting solutions. Faster review, better accuracy & automated generation. Revolutionize your workflow.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI document analysis & drafting solutions. Faster review, better accuracy & automated generation. Revolutionize your workflow.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <DocumentAnalysisContent />
      </div>
      <FooterSection />
    </>
  );
};

export default DocumentAnalysis;
